const useBlackHole = () => {
    return {};
}

export default useBlackHole